
/**
 * Supabase Edge Function email sending strategy
 */
import { supabase } from "@/integrations/supabase/client";
import type { EmailFormData } from '../emailTemplates';
import type { EmailResult } from '../emailTypes';

/**
 * Sends email using Supabase edge function
 */
export const sendEmailViaSupabase = async (formData: EmailFormData): Promise<EmailResult> => {
  console.log('Attempting to use Supabase edge function...');
  
  try {
    const { data, error } = await supabase.functions.invoke('send-email', {
      body: { formData }
    });
    
    if (error) {
      console.warn('Supabase function error:', error);
      throw new Error('Failed to send email using Supabase');
    }
    
    if (data && data.success) {
      console.log('Email sent successfully via Supabase edge function:', data);
      return {
        success: true,
        adminSent: data.adminSent,
        customerSent: data.customerSent
      };
    }
    
    throw new Error('Unexpected response from Supabase function');
  } catch (error) {
    console.warn('Supabase email sending failed:', error);
    throw error;
  }
};
